//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'm-column',
  props: [
    'title'
  ]
}



// WEBPACK FOOTER //
// ./src/components/Column.vue